import styles from './budgetSummaryStat.module.scss';
import Typography from 'src/components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import Selectors from 'src/utils/selectors';
import MoreInfoTooltip from 'src/components/more-info-tooltip/MoreInfoTooltip';
import { trackClick } from 'src/hooks/useAdobeTags';
import SyncLoader from 'src/components/sync-loader/SyncLoader';
import { LoaderType } from 'src/types/loader-type.enum';
import React from 'react';
import colors from 'src/styles/colors.module.scss';

interface BudgetSummaryStatProps {
    title: string;
    tooltip: string;
    amount: string;
    isGreen?: boolean;
    tooltipClassName?: string;
    tagName?: string;
    isMinWidthSmall?: boolean;
    isMinWidthMedium?: boolean;
    pathname: string;
}

export default function BudgetSummaryStat({
    title,
    tooltip,
    amount,
    isGreen,
    tooltipClassName,
    tagName,
    isMinWidthSmall,
    isMinWidthMedium,
    pathname
}: BudgetSummaryStatProps): JSX.Element {
    return (
        <div className={styles.summaryStat}>
            <div className={styles.titleRow}>
                <Typography
                    variant={
                        isMinWidthSmall && !isMinWidthMedium ? TypographyVariants.SUBTEXT : TypographyVariants.CAPTION
                    }
                    component="p"
                    className={styles.statsBoxHeader}
                    data-cy={Selectors.SpendSmart.SUMMARY_STAT_TITLE}
                >
                    {title}
                </Typography>
                <MoreInfoTooltip
                    body={tooltip}
                    className={`${styles.statsBoxTooltip} ${tooltipClassName}`}
                    buttonAriaLabel={title}
                    onClick={() => trackClick(pathname, tagName)}
                />
            </div>
            <div className={styles.amountRow}>
                <SyncLoader type={LoaderType.PILL}>
                    <div className={styles.amountTextOptionalIcon}>
                        <Typography
                            variant={
                                isMinWidthSmall && !isMinWidthMedium
                                    ? TypographyVariants.HEADING_M
                                    : TypographyVariants.HEADING_XS
                            }
                            className={`${isGreen ? colors.goodStrong : ''}`}
                            data-cy={Selectors.SpendSmart.SUMMARY_STAT_AMOUNT}
                            component="p"
                        >
                            {amount}
                        </Typography>
                    </div>
                </SyncLoader>
            </div>
        </div>
    );
}
